<template>
  <div class="flex w-full items-center gap-x-2">
    <slot name="prefix" />
    <span v-tooltipable class="min-w-0 truncate text-headline">
      <slot>
        {{ option }}
      </slot>
    </span>
    <div class="ml-auto flex shrink-0 items-center gap-x-2">
      <slot name="suffix" />
      <icon-base
        v-if="isSelected"
        :icon="IconSent"
        class="shrink-0 text-blue-500"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import IconSent from "@/components/icons/email/IconSent.vue";
import IconBase from "@/components/ui/IconBase.vue";

interface Props {
  modelValue: string;
  selected?: string[];
  option: string;
}
const props = defineProps<Props>();

const isSelected = computed(() => props.selected?.includes(props.modelValue));
</script>
